'use strict';

const jQuery = require('jquery');

const Translator = require('./../../../../core/translator');
const FormBuilder = require('./../../builder');

let ElementClass = require('./../../elementClass');
let ProtocolElement = require('./Element/protocol');

let protocolValue;

FormBuilder.register('url', function(config) {
  let self = {};

  self = new ElementClass(config);

  self.render = function($wrap) {
    let $block = jQuery('<div class="input-group"/>');
    let $element = jQuery('<input/>');
    let $label;

    $element.attr('type', 'text');
    $element.attr('name', self.name);

    if (self.disabled) {
      $element.attr('disabled', self.disabled);
      $element.addClass('disabled');
    }

    if (config.readonly) {
      $element.attr('readonly', 'readonly');
    }

    if (config.autocomplete === false) {
      $element.attr('autocomplete', 'off');
    }

    if (undefined !== self.placeholder) {
      $element.attr('placeholder', self.placeholder);
    }

    if (config.value !== undefined && config.value !== null) {
      protocolValue = ProtocolElement.getValue(config.value);
      $element.val(Translator.translate(ProtocolElement.getURLValue(config.value)));
    }

    if (self.elementClass) {
      $element.addClass(self.elementClass);
    }

    if (typeof config.onChange === 'function') {
      $element.on('change', config.onChange);
    }

    if (self.label || self.question) {
      $label = jQuery('<label/>');

      if (self.labelClass) {
        $label.addClass(self.labelClass);
      }

      $label.append(self.label);

      if (self.question) {
        $label.append(jQuery(`<a class="cloud-question" target="_blank" rel="noopener" href="${self.question}">?</a>`));
      }

      $wrap.append($label);
    }

    $block.append(ProtocolElement.getTemplate(protocolValue));

    $block.append($element);

    $wrap.append($block);

    if (config.description) {
      $wrap.append(jQuery('<blockquote class="cloud-description">' + Translator.translate(config.description) + '</blockquote>'));
    }
  };

  self.getData = function() {
    let $inputValue = self.$.find('input:first').val();
    return $inputValue || '' || null ? self.$.find('select:first').val() + $inputValue : $inputValue;
  };

  return self;
});
